/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';

import { Spinner } from 'sarsaparilla';

import styles from './MapLoadingIndicator.module.scss';

interface MapLoadingIndicatorProps {
    className?: string;
}

export function MapLoadingIndicator({ className }: MapLoadingIndicatorProps) {
    return (
        <div className={cx(styles.root, className)}>
            <Spinner size="sm" />
        </div>
    );
}
